import { STORAGE_KEYS, StorageKey } from "../../config/keys";
import environment from "../../environment/environment";

const ENCRYPTION_KEY = environment.storageKey;

const encrypt = (value: string): string => {
  // Simple XOR encryption for demonstration
  // In production, use a proper encryption library like crypto-js
  return btoa(
    value
      .split("")
      .map((char, i) =>
        String.fromCharCode(
          char.charCodeAt(0) ^
            ENCRYPTION_KEY.charCodeAt(i % ENCRYPTION_KEY.length),
        ),
      )
      .join(""),
  );
};

const decrypt = (encrypted: string): string => {
  try {
    const decoded = atob(encrypted);
    return decoded
      .split("")
      .map((char, i) =>
        String.fromCharCode(
          char.charCodeAt(0) ^
            ENCRYPTION_KEY.charCodeAt(i % ENCRYPTION_KEY.length),
        ),
      )
      .join("");
  } catch {
    return "";
  }
};

export const storage = {
  set: (key: string, value: any): void => {
    const stringValue = JSON.stringify(value);
    const encrypted = encrypt(stringValue);
    localStorage.setItem(key, encrypted);
  },

  get: <T>(key: string, defaultValue: T): T => {
    const encrypted = localStorage.getItem(key);
    if (!encrypted) return defaultValue;

    try {
      const decrypted = decrypt(encrypted);
      return JSON.parse(decrypted) as T;
    } catch {
      return defaultValue;
    }
  },

  remove: (key: StorageKey): void => {
    localStorage.removeItem(STORAGE_KEYS[key]);
  },

  clear: (): void => {
    try {
      Object.keys(localStorage).forEach((key) => {
        localStorage.removeItem(key);
      });
    } catch (error) {
      console.error('Error clearing localStorage:', error);
    }
  },
};
